import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { DatabaseBrowserPage } from "@/components/developer/database-browser-page";
import { Route as authenticatedFullBleedRoute } from "../_authenticatedFullBleed";

export const Route = createRoute({
  getParentRoute: () => authenticatedFullBleedRoute,
  path: "/database-browser",
  loader: async () => {
    const res = await fetch("/api/schema/tables");
    if (!res.ok) return [];
    return res.json();
  },
  component: DatabaseBrowserGuard,
});

function DatabaseBrowserGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <DatabaseBrowserPage />;
}
